export const Common = {
  TAABL_PROFIT_NON_PARTICIPATING: 1 / 3,
  TAABL_PROFIT_PARTICIPATING: 0.06,
  ALLOWED_STATES_FOR_SIGNUP: ['UT', 'CA'],
};
